<template>
  <div>
    <TableView
      :bordered="true"
      :loading="loading"
      :scroll="scroll"
      ref="table"
      :columns="columns"
      :pagination="pageData"
      :data="tableData"
      rowKey="index"
      v-on:handlePagination="handlePagination"
    >
      <!--Total AR-->
      <template v-slot:arAmount="{ tableRow }">
        <a-popover
          trigger="click"
          placement="bottom"
          @click="dataOpen($event, tableRow.date)"
        >
          <span>
            {{ tableRow.arAmount | formatAmount }}
          </span>
          <a slot="content">
            <a-table
              :columns="yqColumns"
              :dataSource="yqData"
              :pagination="false"
              :rowKey="
                (record, index) => {
                  return index
                }
              "
            >
              <!-- 合计 totalRow-->
              <span slot="totalRow" slot-scope="totalRow">
                {{ totalRow | formatAmount }}
              </span>
              <!-- 未逾期  notOverdue-->
              <span slot="notOverdue" slot-scope="notOverdue">
                {{ notOverdue | formatAmount }}
              </span>
              <!-- 逾期1-30D -->
              <span slot="overdueOne" slot-scope="overdueOne">
                {{ overdueOne | formatAmount }}
              </span>
              <!-- 逾期31-60D -->
              <span slot="overdueThirty" slot-scope="overdueThirty">
                {{ overdueThirty | formatAmount }}
              </span>
              <!-- 逾期61-90D -->
              <span slot="overdueSixty" slot-scope="overdueSixty">
                {{ overdueSixty | formatAmount }}
              </span>
              <!-- 逾期91-180D -->
              <span slot="overdueNinety" slot-scope="overdueNinety">
                {{ overdueNinety | formatAmount }}
              </span>
              <!-- 逾期大于180D -->
              <span
                slot="overdueHundredEighty"
                slot-scope="overdueHundredEighty"
              >
                {{ overdueHundredEighty | formatAmount }}
              </span>
            </a-table>

            <a-table
              :columns="tatalColumns"
              :dataSource="surplusList"
              :pagination="false"
              :rowKey="
                (record, index) => {
                  return index
                }
              "
            >
              <!-- 合计 totalRow-->
              <span slot="totalRow" slot-scope="totalRow">
                {{ totalRow | formatAmount }}
              </span>
              <!-- 未逾期  notOverdue-->
              <span slot="notOverdue" slot-scope="notOverdue">
                {{ notOverdue | formatAmount }}
              </span>
              <!-- 逾期1-30D -->
              <span slot="overdueOne" slot-scope="overdueOne">
                {{ overdueOne | formatAmount }}
              </span>
              <!-- 逾期31-60D -->
              <span slot="overdueThirty" slot-scope="overdueThirty">
                {{ overdueThirty | formatAmount }}
              </span>
              <!-- 逾期61-90D -->
              <span slot="overdueSixty" slot-scope="overdueSixty">
                {{ overdueSixty | formatAmount }}
              </span>
              <!-- 逾期91-180D -->
              <span slot="overdueNinety" slot-scope="overdueNinety">
                {{ overdueNinety | formatAmount }}
              </span>
              <!-- 逾期大于180D -->
              <span
                slot="overdueHundredEighty"
                slot-scope="overdueHundredEighty"
              >
                {{ overdueHundredEighty | formatAmount }}
              </span>
            </a-table>
          </a>
        </a-popover>
      </template>

      <!--RMB-->
      <template v-slot:grAmountRmbHandle="{ tableRow }">
        <a-popover
          trigger="click"
          placement="bottom"
          @click="dataRmdOpen($event, tableRow.date)"
        >
          <span>
            {{ tableRow.grAmountRmbHandle | formatAmount }}
          </span>
          <a slot="content">
            <a-table
              :columns="rmbColumns"
              :dataSource="rmbData"
              :pagination="false"
              :rowKey="
                (record, index) => {
                  return index
                }
              "
            >
              <!-- 合计 totalRmb-->
              <span slot="totalRmb" slot-scope="totalRmb">
                {{ totalRmb | formatAmount }}
              </span>
              <!-- Vendor-->
              <span slot="vendor" slot-scope="vendor">
                {{ vendor | formatAmount }}
              </span>
              <!-- 密钥打开时间 -->
              <!-- <span slot="keyOpenDate" slot-scope="keyOpenDate">
                {{ keyOpenDate | formatAmount }}
              </span> -->
              <!-- AP -->
              <span slot="apAmountRmb" slot-scope="apAmountRmb">
                {{ apAmountRmb | formatAmount }}
              </span>
              <!-- GR -->
              <span slot="grAmountRmb" slot-scope="grAmountRmb">
                {{ grAmountRmb | formatAmount }}
              </span>
              <!-- GR 不含税 -->
              <span slot="grAmountRmbHandle" slot-scope="grAmountRmbHandle">
                {{ grAmountRmbHandle | formatAmount }}
              </span>
            </a-table>

            <a-table
              :columns="sumColumns"
              :dataSource="sumList"
              :pagination="false"
              :rowKey="
                (record, index) => {
                  return index
                }
              "
            >
              <!-- 合计 totalRmb-->
              <span slot="totalRmb" slot-scope="totalRmb">
                {{ totalRmb | formatAmount }}
              </span>
              <!-- AP-->
              <span slot="apAmountRmb" slot-scope="apAmountRmb">
                {{ apAmountRmb | formatAmount }}
              </span>
              <!-- GR -->
              <span slot="grAmountRmb" slot-scope="grAmountRmb">
                {{ grAmountRmb | formatAmount }}
              </span>
              <!--GR 不含税 -->
              <span slot="grAmountRmbHandle" slot-scope="grAmountRmbHandle">
                {{ grAmountRmbHandle | formatAmount }}
              </span>
            </a-table>
          </a>
        </a-popover>
      </template>

      <!--USD-->
      <template v-slot:grAmountUsdHandle="{ tableRow }">
        <a-popover
          trigger="click"
          placement="bottom"
          @click="dataRmdOpen($event, tableRow.date)"
        >
          <span>
            {{ tableRow.grAmountUsdHandle | formatAmount }}
          </span>
          <a slot="content">
            <a-table
              :columns="usdColumns"
              :dataSource="rmbData"
              :pagination="false"
              :rowKey="
                (record, index) => {
                  return index
                }
              "
            >
              <!-- 合计 totalUsd-->
              <span slot="totalUsd" slot-scope="totalUsd">
                {{ totalUsd | formatAmount }}
              </span>
              <!-- Vendor-->
              <span slot="vendor" slot-scope="vendor">
                {{ vendor | formatAmount }}
              </span>
              <!-- 密钥打开时间 -->
              <!-- <span slot="keyOpenDate" slot-scope="keyOpenDate">
                {{ keyOpenDate | formatAmount }}
              </span> -->
              <!-- AP -->
              <span slot="apAmountUsd" slot-scope="apAmountUsd">
                {{ apAmountUsd | formatAmount }}
              </span>
              <!-- GR -->
              <span slot="grAmountUsd" slot-scope="grAmountUsd">
                {{ grAmountUsd | formatAmount }}
              </span>
              <!-- GR 不含税 -->
              <span slot="grAmountUsdHandle" slot-scope="grAmountUsdHandle">
                {{ grAmountUsdHandle | formatAmount }}
              </span>
            </a-table>

            <a-table
              :columns="sumUsdColumns"
              :dataSource="sumList"
              :pagination="false"
              :rowKey="
                (record, index) => {
                  return index
                }
              "
            >
              <!-- totalUsd -->
              <span slot="totalUsd" slot-scope="totalUsd">
                {{ totalUsd | formatAmount }}
              </span>
              <!-- AP -->
              <span slot="apAmountUsd" slot-scope="apAmountUsd">
                {{ apAmountUsd | formatAmount }}
              </span>
              <!-- GR -->
              <span slot="grAmountUsd" slot-scope="grAmountUsd">
                {{ grAmountUsd | formatAmount }}
              </span>
              <!-- GR 不含税 -->
              <span slot="grAmountUsdHandle" slot-scope="grAmountUsdHandle">
                {{ grAmountUsdHandle | formatAmount }}
              </span>
            </a-table>
          </a>
        </a-popover>
      </template>

      <!--AP RMB-->
      <template v-slot:apAmountRmb="{ tableRow }">
        <span>{{ tableRow.apAmountRmb | formatAmount }}</span>
      </template>
      <!--AP USD-->
      <template v-slot:apAmountUsd="{ tableRow }">
        <span>{{ tableRow.apAmountUsd | formatAmount }}</span>
      </template>
      <!--GR RMB-->
      <template v-slot:grAmountRmb="{ tableRow }">
        <span>{{ tableRow.grAmountRmb | formatAmount }}</span>
      </template>
      <!--GR USD-->
      <template v-slot:grAmountUsd="{ tableRow }">
        <span>{{ tableRow.grAmountUsd | formatAmount }}</span>
      </template>

      <!--未清来款-->
      <template v-slot:amountReceipt="{ tableRow }">
        <span>{{ tableRow.amountReceipt | formatAmount }}</span>
      </template>
      <!--Net AR-->
      <template v-slot:netAr="{ tableRow }">
        <span>{{ tableRow.netAr | formatAmount }}</span>
      </template>
      <!--集团 Net AR-->
      <template v-slot:groupNetAr="{ tableRow }">
        <span>{{ tableRow.groupNetAr | formatAmount }}</span>
      </template>
      <!--尚未逾期(元)-->
      <template v-slot:notOverdue="{ tableRow }">
        <span>{{ tableRow.notOverdue | formatAmount }}</span>
      </template>
      <!--逾期1-30D-->
      <template v-slot:overdueOne="{ tableRow }">
        <span>{{ tableRow.overdueOne | formatAmount }}</span>
      </template>
      <!--逾期31-60D slot-->
      <template v-slot:overdueThirty="{ tableRow }">
        <span>{{ tableRow.overdueThirty | formatAmount }}</span>
      </template>
      <!--逾期31-60D slot-->
      <template v-slot:overdueSixty="{ tableRow }">
        <span>{{ tableRow.overdueSixty | formatAmount }}</span>
      </template>
      <!--逾期91-180D slot-->
      <template v-slot:overdueNinety="{ tableRow }">
        <span>{{ tableRow.overdueNinety | formatAmount }}</span>
      </template>
      <!--逾期大于180D slot-->
      <template v-slot:overdueHundredEighty="{ tableRow }">
        <span>{{ tableRow.overdueHundredEighty | formatAmount }}</span>
      </template>
    </TableView>
  </div>
</template>

<script>
import { TableView } from 'lxfintech-fe'
import moment from 'moment'
import numeral from 'numeral'
import mixin from './mixin'
//getOverview
import { getTableData, getYqData, getRmbData } from '../api'
const formatAmount = num => {
  return numeral(num).format('0,0.00')
}
const yqColumns = [
  {
    dataIndex: 'companyCode',
    key: 'companyCode',
    width: 100,
    title: '公司代码',
  },
  {
    title: '信控区',
    dataIndex: 'creditControlArea',
    width: 100,
    key: 'creditControlArea',
  },
  {
    title: '合计',
    width: 120,
    key: 'totalRow',
    dataIndex: 'totalRow',
    scopedSlots: { customRender: 'totalRow' },
  },
  {
    title: '未逾期',
    dataIndex: 'notOverdue',
    scopedSlots: { customRender: 'notOverdue' },
    width: 120,
    key: 'notOverdue',
  },
  {
    width: 120,
    title: '逾期1-30D',
    key: 'overdueOne',
    scopedSlots: { customRender: 'overdueOne' },
    dataIndex: 'overdueOne',
  },
  {
    title: '逾期31-60D',
    width: 120,
    key: 'overdueThirty',
    scopedSlots: { customRender: 'overdueThirty' },
    dataIndex: 'overdueThirty',
  },
  {
    title: '逾期61-90D',
    dataIndex: 'overdueSixty',
    width: 120,
    scopedSlots: { customRender: 'overdueSixty' },
    key: 'overdueSixty',
  },
  {
    title: '逾期91-180D',
    key: 'overdueNinety',
    width: 120,
    scopedSlots: { customRender: 'overdueNinety' },
    dataIndex: 'overdueNinety',
  },
  {
    title: '逾期大于180D',
    scopedSlots: { customRender: 'overdueHundredEighty' },
    key: 'overdueHundredEighty',
    width: 120,
    dataIndex: 'overdueHundredEighty',
  },
]
const tatalColumns = [
  {
    width: 250,
    title: '总计',
    key: 'totalRow',
    dataIndex: 'totalRow',
    className: 'column-money',
    scopedSlots: { customRender: 'totalRow' },
  },
  {
    title: '未逾期',
    dataIndex: 'notOverdue',
    scopedSlots: { customRender: 'notOverdue' },
    width: 120,
    key: 'notOverdue',
  },
  {
    width: 120,
    title: '逾期1-30D',
    key: 'overdueOne',
    scopedSlots: { customRender: 'overdueOne' },
    dataIndex: 'overdueOne',
  },
  {
    title: '逾期31-60D',
    width: 120,
    key: 'overdueThirty',
    scopedSlots: { customRender: 'overdueThirty' },
    dataIndex: 'overdueThirty',
  },
  {
    title: '逾期61-90D',
    dataIndex: 'overdueSixty',
    width: 120,
    scopedSlots: { customRender: 'overdueSixty' },
    key: 'overdueSixty',
  },
  {
    title: '逾期91-180D',
    key: 'overdueNinety',
    width: 120,
    scopedSlots: { customRender: 'overdueNinety' },
    dataIndex: 'overdueNinety',
  },
  {
    title: '逾期大于180D',
    scopedSlots: { customRender: 'overdueHundredEighty' },
    key: 'overdueHundredEighty',
    width: 120,
    dataIndex: 'overdueHundredEighty',
  },
]
const rmbColumns = [
  {
    dataIndex: 'companyCode',
    key: 'companyCode',
    width: 100,
    title: '公司代码',
  },
  {
    title: 'Vendor',
    dataIndex: 'vendor',
    width: 100,
    key: 'vendor',
  },
  //  {
  //   title: '密钥打开时间',
  //   dataIndex: 'keyOpenDate',
  //   width: 100,
  //   key: 'keyOpenDate',
  // },
  {
    title: '合计',
    width: 120,
    key: 'totalRmb',
    dataIndex: 'totalRmb',
    scopedSlots: { customRender: 'totalRmb' },
  },
  {
    title: 'AP',
    dataIndex: 'apAmountRmb',
    scopedSlots: { customRender: 'apAmountRmb' },
    width: 120,
    key: 'apAmountRmb',
  },
  {
    width: 120,
    title: 'GR',
    key: 'grAmountRmb',
    scopedSlots: { customRender: 'grAmountRmb' },
    dataIndex: 'grAmountRmb',
  },
  {
    title: 'GR 不含税',
    width: 120,
    key: 'grAmountRmbHandle',
    scopedSlots: { customRender: 'grAmountRmbHandle' },
    dataIndex: 'grAmountRmbHandle',
  },
]
const sumColumns = [
  {
    width: 250,
    title: '总计',
    key: 'totalRmb',
    dataIndex: 'totalRmb',
    className: 'column-money',
    scopedSlots: { customRender: 'totalRmb' },
  },
  {
    title: 'AP',
    dataIndex: 'apAmountRmb',
    scopedSlots: { customRender: 'apAmountRmb' },
    width: 120,
    key: 'apAmountRmb',
  },
  {
    width: 120,
    title: 'GR',
    key: 'grAmountRmb',
    scopedSlots: { customRender: 'grAmountRmb' },
    dataIndex: 'grAmountRmb',
  },
  {
    title: 'GR 不含税',
    width: 120,
    key: 'grAmountRmbHandle',
    scopedSlots: { customRender: 'grAmountRmbHandle' },
    dataIndex: 'grAmountRmbHandle',
  },
]
const usdColumns = [
  {
    dataIndex: 'companyCode',
    key: 'companyCode',
    width: 100,
    title: '公司代码',
  },
  {
    title: 'Vendor',
    dataIndex: 'vendor',
    width: 100,
    key: 'vendor',
  },
  //  {
  //   title: '密钥打开时间',
  //   dataIndex: 'keyOpenDate',
  //   width: 100,
  //   key: 'keyOpenDate',
  // },
  {
    title: '合计',
    width: 120,
    key: 'totalUsd',
    dataIndex: 'totalUsd',
    scopedSlots: { customRender: 'totalUsd' },
  },
  {
    title: 'AP',
    dataIndex: 'apAmountUsd',
    scopedSlots: { customRender: 'apAmountUsd' },
    width: 120,
    key: 'apAmountUsd',
  },
  {
    width: 120,
    title: 'GR',
    key: 'grAmountUsd',
    scopedSlots: { customRender: 'grAmountUsd' },
    dataIndex: 'grAmountUsd',
  },
  {
    title: 'GR 不含税',
    width: 120,
    key: 'grAmountUsdHandle',
    scopedSlots: { customRender: 'grAmountUsdHandle' },
    dataIndex: 'grAmountUsdHandle',
  },
]
const sumUsdColumns = [
  {
    width: 250,
    title: '总计',
    key: 'totalUsd',
    dataIndex: 'totalUsd',
    className: 'column-money',
    scopedSlots: { customRender: 'totalUsd' },
  },
  {
    title: 'AP',
    dataIndex: 'apAmountUsd',
    scopedSlots: { customRender: 'apAmountUsd' },
    width: 120,
    key: 'apAmountUsd',
  },
  {
    width: 120,
    title: 'GR',
    key: 'grAmountUsd',
    scopedSlots: { customRender: 'grAmountUsd' },
    dataIndex: 'grAmountUsd',
  },
  {
    title: 'GR 不含税',
    width: 120,
    key: 'grAmountUsdHandle',
    scopedSlots: { customRender: 'grAmountUsdHandle' },
    dataIndex: 'grAmountUsdHandle',
  },
]

export default {
  mixins: [mixin],
  components: {
    TableView,
  },
  data() {
    return {
      surplusList: [],
      scroll: { x: 2300 }, //滚动设置,
      tableData: [],
      yqData: [],
      rmbData: [],
      sumList: [],
      tatalColumns,
      date: '',
      formatAmount,
      rowKey: 'index',
      moment,
      yqColumns,
      loading: false,
      rmbColumns,
      sumColumns,
      usdColumns,
      sumUsdColumns,
    }
  },
  props: ['searchData'],
  computed: {},
  mounted() {
    this._getTableData()
  },
  methods: {
    // 获取单条数据的date值
    dataOpen(e, date) {
      ;(this.date = moment(new Date(date))
        .subtract(-1, 'days')
        .format('YYYY-MM-DD hh:mm:ss')),
        this._getYqData()
    },
    // 获取表格中TotalAR数据
    async _getYqData() {
      try {
        const query = {
          companyId: this.$route.params.id,
          createTime: this.date,
        }
        const { data } = await getYqData(query)
        this.surplusList = data.surplusList
        this.yqData = data.companyArDetailVOList
      } catch (error) {
        console.log(error)
      }
    },

    // 获取单条数据的date值
    dataRmdOpen(e, date) {
      ;(this.date = moment(new Date(date))
        .subtract(-1, 'days')
        .format('YYYY-MM-DD hh:mm:ss')),
        this._getRmbData()
    },
    // 获取表格中RMB数据
    async _getRmbData() {
      try {
        const query = {
          companyId: this.$route.params.id,
          createTime: this.date,
        }
        const { data } = await getRmbData(query)
        this.sumList = data.sumList
        this.rmbData = data.companyApGrDetailVOList
      } catch (error) {
        console.log(error)
      }
    },

    //获取table数据
    async _getTableData() {
      try {
        this.loading = true
        const { current, pageSize } = this.pageData
        const query = {
          ...this.searchData,
          companyId: this.$route.params.id,
          size: pageSize,
          current,
        }
        delete query.pageSize
        const {
          data: { total, records },
        } = await getTableData(query)
        this.loading = false
        this.pageData.total = total
        this.tableData = [...records]
        if (records.length !== 0) {
          for (let i = 0; i < records.length; i++) {
            this.tableData[i].index = i
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    //分页
    handlePagination(pagination) {
      const { current, pageSize, total } = pagination
      this.pageData.current = current
      this.pageData.pageSize = pageSize
      this.pageData.total = total
      this._getTableData()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.column-money {
  text-align: right !important;
}
</style>
